import { Option } from './Interfaces';

let I18n = {
    install: function install(Vue: any, options: object)
    {
        let config = Object.assign({
            locale: null,
            languages: {} as any,
            translations: {} as any,
            nugget: {
                beginToken: '[' + '[[', // + is to disable triggering the translate parser in this file
                endToken: ']]' + ']', // + is to disable triggering the translate parser in this file
                delimiterToken: '|||',
                commentToken: '///',
                msgkeyDelimiter: ':£#£#£:'
            },
            variableToken: ['{', '}'],
            messageContextEnabled: true
        }, options);

        config = Vue.observable(config);

        let variableMatcher = new RegExp('' + config.variableToken[0] + '\\w+' + config.variableToken[1], 'g');

        let getLocale = function(): string
        {
            return config.locale || '';
        };
        let setLocale = function(locale: string): void
        {
            config.locale = locale;
        };
        let addLocale = function(locale: string, translations: object): void
        {
            config.translations[locale] = translations;
        };
        let getShortLocale = function(): string
        {
            return getLocale().split('-')[0];
        };
        let detectLocale = function(defaultLocale: string): void
        {
            // @ts-ignore
            var locale = navigator.language || navigator.userLanguage;
            var supportedCultures = Object.keys(config.translations);

            config.locale = null;

            for (let i = 0; i < supportedCultures.length; i++)
            {
                if (supportedCultures[i] === locale)
                {
                    config.locale = supportedCultures[i];
                    break;
                }
            }

            if (config.locale == null)
            {
                for (let i = 0; i < supportedCultures.length; i++)
                {
                    if (supportedCultures[i].split('-')[0] === locale)
                    {
                        config.locale = supportedCultures[i];
                        break;
                    }
                }
            }

            if (config.locale == null)
            {
                config.locale = defaultLocale;
            }
        };
        let checkLocaleExists = function(locale: string): boolean
        {
            return config.translations.hasOwnProperty(locale);
        };
        let checkKeyExists = function(key: string): boolean
        {
            let locale = getLocale();
            let translations = config.translations;

            if (translations.hasOwnProperty(locale) === false)
            {
                return false;
            }

            return translations[locale].hasOwnProperty(key);
        };
        let getNugget = function(key: string): any
        {
            let params = key
                .replace(config.nugget.beginToken, '')
                .replace(config.nugget.endToken, '')
                .split(config.nugget.commentToken);

            let nuget = {
                msgId: params[0].split(config.nugget.delimiterToken)[0],
                comment: params.length === 2 ? params[1] : null,
                formatItems: params[0].split(config.nugget.delimiterToken).splice(1)
            };

            return nuget;
        };
        let getMsgKey = function(nugget: any): string
        {
            if (config.messageContextEnabled && nugget.comment != null && nugget.comment.length > 0)
            {
                return `${nugget.msgId}${config.nugget.msgkeyDelimiter}${nugget.comment}`;
            }

            return nugget.msgId;
        };
        let translate = function(key: string, replacements? : any): string
        {
            let nugget = getNugget(key);
            let msgkey = getMsgKey(nugget);
            let message = '';

            let locale = getLocale();
            let translations = config.translations;

            if (translations.hasOwnProperty(locale) && translations[locale].hasOwnProperty(msgkey))
            {
                message = translations[locale][msgkey];
            }

            if (message.length === 0)
            {
                message = nugget.msgId;
            }

            if (arguments.length === 2 && typeof replacements !== 'object' && typeof replacements !== typeof Array)
            {
                replacements = [replacements];
            }
            else if (arguments.length > 2)
            {
                replacements = Array.prototype.slice.call(arguments, 1);
            }

            if (nugget.formatItems.length > 0)
            {
                // Example: this.$t('[[[Pozostało %0 znaków.|||{0}]]]', value)
                if (replacements !== null && typeof replacements === 'object')
                {
                    for (let i = 0; i < nugget.formatItems.length; i++)
                    {
                        message = message.replace(`%${i}`, nugget.formatItems[i]);
                    }

                    message = message.replace(variableMatcher, function(placeholder)
                    {
                        let key = placeholder.replace(config.variableToken[0], '').replace(config.variableToken[1], '');

                        if (replacements[key] !== undefined)
                        {
                            return replacements[key];
                        }

                        return placeholder;
                    });
                }
            }

            // Zamiana `` na znak ". Czasami się przydaje.
            return message.replace(/``/g, '"');
        };
        let setTranslations = function(messages: any): void
        {
            config.translations = messages;
        };
        let getCodes = function(): string[]
        {
            return Object.keys(config.languages);
        };
        let getLanguages = function(): Record<string, string>
        {
            return config.languages;
        };
        let setLanguages = function(languages: Record<string, string>): void
        {
            config.languages = languages;
        };
        let getLanguageOptions = function(): Option[]
        {
            return Object.keys(config.languages).map(p =>
            {
                return { value: p.split('-')[0], text: translate(config.languages[p]) };
            });
        };
        let makeReactive = function(item: object, codes? : string[]): void
        {
            (codes || getCodes()).forEach(locale =>
            {
                Vue.set(item, locale, item[locale] || '');
            });
        };

        Vue.i18n = Vue.prototype.$i18n = {
            locale: getLocale,
            set: setLocale,
            add: addLocale,
            shortLocale: getShortLocale,
            detectLocale: detectLocale,
            localeExists: checkLocaleExists,
            keyExists: checkKeyExists,
            setTranslations: setTranslations,
            languages: getLanguages,
            setLanguages: setLanguages,
            options: getLanguageOptions,
            codes: getCodes,
            reactive: makeReactive,
            translate: translate,
            $t: translate,
            __: translate
        };

        Vue.prototype.$t = translate;
        Vue.prototype.__ = translate;

        Vue.filter('translate', translate);
    }
};

export default I18n;

declare module 'vue/types/vue'
{
    interface Vue
    {
        $i18n: {
            locale(): string;
            set(locale: string): void;
            add(locale: string, translations: object): void;
            shortLocale(): string;
            detectLocale(defaultLocale: string): void;
            localeExists(locale: string): boolean;
            keyExists(key: string): boolean;
            setTranslations(messages: any): void;
            languages(): Record<string, string>;
            options(): Option[];
            codes(): string[];
            reactive(item: object, codes? : string[]): void;
            translate(key: string, ...replacements: any[]): string;
            $t(key: string, ...replacements: any[]): string;
            __(key: string, ...replacements: any[]): string;
        };
        $t(key: string, ...replacements: any[]): string;
        __(key: string, ...replacements: any[]): string;
    }
    interface VueConstructor
    {
        i18n: {
            locale(): string;
            set(locale: string): void;
            add(locale: string, translations: object): void;
            shortLocale(): string;
            detectLocale(defaultLocale: string): void;
            localeExists(locale: string): boolean;
            keyExists(key: string): boolean;
            setTranslations(messages: any): void;
            languages(): Record<string, string>;
            setLanguages(languages: Record<string, string>): void;
            options(): Option[];
            codes(): string[];
            reactive(item: object, codes? : string[]): void;
            translate(key: string, ...replacements: any[]): string;
            $t(key: string, ...replacements: any[]): string;
            __(key: string, ...replacements: any[]): string;
        };
    }
}
